module.exports = __webpack_public_path__ + "static/img/3.e13c6f88.svg";